export default function LogoMark({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none">
      <path d="M9 2L15.5 5.75V12.25L9 16L2.5 12.25V5.75L9 2Z" stroke="white" strokeWidth="1.6" strokeLinejoin="round"/>
      <circle cx="9" cy="9" r="2.5" fill="white"/>
    </svg>
  );
}
